import VueI18n from "vue-i18n";

const money = function (value: number, translator: VueI18n): string {
  if (value === 0.0) {
    return translator.t("prices.free").toString();
  }

  return translator.n(value, "currency");
};

export default money;
